import { Component } from 'react';
import { AlertTriangle, RefreshCw } from 'lucide-react';
import { Button } from './button';

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error(`[ErrorBoundary ${this.props.name || 'unknown'}]:`, error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex flex-col items-center justify-center py-16 px-6" data-testid={`error-boundary-${this.props.name || 'fallback'}`}>
          <div className="h-14 w-14 rounded-2xl bg-red-50 flex items-center justify-center mb-4">
            <AlertTriangle className="h-7 w-7 text-red-500" strokeWidth={1.5} />
          </div>
          <h3 className="text-base font-semibold text-black mb-1">Er ging iets mis</h3>
          <p className="text-sm text-neutral-500 text-center max-w-sm mb-4">
            {this.props.fallbackMessage || 'Dit onderdeel kon niet geladen worden. Probeer de pagina opnieuw te laden.'}
          </p>
          <Button
            variant="outline"
            size="sm"
            className="border-neutral-200"
            onClick={() => this.setState({ hasError: false, error: null })}
            data-testid="error-boundary-retry"
          >
            <RefreshCw className="h-3.5 w-3.5 mr-1.5" strokeWidth={1.5} />
            Opnieuw proberen
          </Button>
        </div>
      );
    }

    return this.props.children;
  }
}
